import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { DesktopLoanSummary } from './DesktopLoanSummary/DesktopLoanSummary';
import { MobileLoanSummary } from './MobileLoanSummary/MobileLoanSummary';
import { useMediaQuery } from '../../../../../customHooks/useMediaQuery';
import { getNonInterestOnlyPaymentAmount } from '../../../MyOffers.helpers';

export const LoanSummary = ({
    selectedOffer,
    drawdownAmount,
    isSingleOffer
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number | undefined;
    isSingleOffer: boolean;
}) => {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    const { data, isLoading } = useDrawdownRepaymentSchedule({
        offerId: selectedOffer?.offer_id ?? '',
        drawdownAmount: drawdownAmount ?? 0,
        enabled: Boolean(selectedOffer) && Boolean(drawdownAmount)
    });

    let monthlyRepayment: number | null = null;
    if (data) {
        if (data.summary.is_equal_repayment) {
            monthlyRepayment =
                data.summary.simplified_schedule?.equal_repayments?.amount ??
                null;
        } else {
            monthlyRepayment =
                getNonInterestOnlyPaymentAmount(data.schedule) ?? null;
        }
    }

    return isDesktop ? (
        <DesktopLoanSummary
            selectedOffer={selectedOffer}
            drawdownAmount={drawdownAmount}
            isSingleOffer={isSingleOffer}
            monthlyRepayment={monthlyRepayment}
            isLoading={isLoading}
        />
    ) : (
        <MobileLoanSummary
            selectedOffer={selectedOffer}
            drawdownAmount={drawdownAmount}
            isSingleOffer={isSingleOffer}
            monthlyRepayment={monthlyRepayment}
            isLoading={isLoading}
        />
    );
};
